import { styled, Typography, TypographyProps } from "@mui/material";

const StyledTypography = styled(Typography)(({ theme }) => ({
  fontStyle: "italic",
  color: theme.palette.text.disabled,
}));

const EmptyMessage: React.FC<TypographyProps> = (props) => {
  return <StyledTypography {...props} />;
};

export default EmptyMessage;
